import { gql } from "graphql-request";

export const CREATE_STAFF_WORK_PATTERN = gql`
  mutation CreateStaffWorkPattern($input: CreateStaffWorkPatternInput!) {
    createStaffWorkPattern(input: $input) {
      id
      tenantID
      staffTenantUserID
      leaveYearID
      name
      effectiveFrom
      effectiveTo
      days {
        dayOfWeek
        isWorkingDay
        startTime
        endTime
        unpaidBreakMinutes
        scheduledMinutes
      }
    }
  }
`;

export const UPDATE_STAFF_WORK_PATTERN = gql`
  mutation UpdateStaffWorkPattern($input: UpdateStaffWorkPatternInput!) {
    updateStaffWorkPattern(input: $input) {
      id
      name
      leaveYearID
      effectiveFrom
      effectiveTo
      days {
        dayOfWeek
        isWorkingDay
        startTime
        endTime
        unpaidBreakMinutes
        scheduledMinutes
      }
    }
  }
`;

export const DELETE_STAFF_WORK_PATTERN = gql`
  mutation DeleteStaffWorkPattern($id: ID!) {
    deleteStaffWorkPattern(id: $id)
  }
`;